import Vue from 'vue'
import App from './App.vue'
import './plugins/element.js'
import router from './router'
import 'bootstrap/dist/css/bootstrap.css'
import './assets/css/common.less'
import './assets/css/app.less'
import './filters'
Vue.config.productionTip = false
import 'jquery/dist/jquery.min'
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
    ak: 'gDo1iGvV5swBcO0aMjIte8Hwp4Dvuj2k'
})
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
import topCarousel from './components/pages/commonComponents/topCarousel.vue'
Vue.component('topCarousel', topCarousel)
new Vue({
    router,
    render: (h) => h(App),
}).$mount('#app')
